// ADDED: Stimulus controller for website onboarding wizard
// PRD Reference: Dashboard Redesign + Website Onboarding Wizard plan
import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import WizardApp from '~/javascript/components/onboarding/wizard.vue'

export default class extends Controller {
  static targets = ['modal']

  static values = {
    mapKey: String,
    websiteId: String,
    initialStep: { type: Number, default: 1 }
  }

  connect() {
    this.vueApp = null
    this.isOpen = false
  }

  disconnect() {
    this.closeWizard()
  }

  openWizard() {
    if (this.isOpen) return

    this.isOpen = true
    this.showModal()
    this.mountVueApp()
  }

  closeWizard() {
    if (!this.isOpen) return

    this.isOpen = false
    this.unmountVueApp()
    this.hideModal()
  }

  showModal() {
    // Show modal container
    this.modalTarget.classList.remove('hidden')

    // Prevent body scroll
    document.body.style.overflow = 'hidden'
  }

  hideModal() {
    // Hide modal container
    this.modalTarget.classList.add('hidden')

    // Restore body scroll
    document.body.style.overflow = ''
  }

  mountVueApp() {
    if (this.vueApp) return

    const props = {
      mapKey: this.mapKeyValue,
      websiteId: this.websiteIdValue,
      initialStep: this.initialStepValue,
      onClose: () => this.closeWizard(),
      onComplete: () => this.handleWizardComplete()
    }

    this.vueApp = createApp(WizardApp, props)
    this.vueApp.mount(this.modalTarget)
  }

  unmountVueApp() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }

  handleWizardComplete() {
    this.closeWizard()
    // Reload the page to show updated dashboard state
    window.location.reload()
  }
}
